


































import { Component, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';
import ResponsiveImage from 'frontend/components/ResponsiveImage.vue';

@Component({
  components: {
    ResponsiveImage,
  },
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class LandingHero extends Vue {
  private isMobile!: MobileGetter;
}
